module.exports = __webpack_public_path__ + "img/logo-icon.a1a83bf0.svg";